/* 
 * Export component file to be used on project
*/

import ProfileListItem from './ProfileListItem.js';
export default ProfileListItem;
